export default function scrollToError(formErrors = {}, fieldOrder = []) {
  const pageErrors = Object.keys(formErrors);
  const firstErroredField = fieldOrder.find((field) => pageErrors.includes(field));
  const fieldSelector = `#${firstErroredField}`;
  return firstErroredField ? document.querySelector(fieldSelector)?.focus() : '';
}
